import React, { useEffect, useState } from 'react';
import ProductList from './ProductList';
import './ProductList.css';
export default function AlertDashboard({ activeCount, allowedLimit, urlInput, children, ...listProps }) {
  const [adding, setAdding] = useState(false);
  const atLimit = activeCount >= allowedLimit;
  const showForm = !atLimit && (adding || !listProps.urls.length || !!urlInput);
  useEffect(() => { if(!urlInput) setAdding(false); }, [urlInput]);
  return <main className="alert-dashboard">
    <header className="dashboard-heading"><div><span className="dashboard-eyebrow">TU LISTA, A TU RITMO</span><h1>Mis alertas <span>{activeCount} de {allowedLimit}</span></h1><p>Gestiona tus productos y los avisos por email.</p></div>
      {!atLimit && <button type="button" className="dashboard-add" aria-expanded={showForm} aria-controls="dashboard-form" onClick={() => { setAdding(!adding); requestAnimationFrame(() => document.getElementById('product-url')?.focus()); }}>Añadir producto +</button>}
    </header>
    {atLimit && <p className="dashboard-limit">Tienes {activeCount} de {allowedLimit} seguimientos ocupados. Para añadir otro producto, elimina uno que ya no te interese. Pausar los avisos no libera espacio.</p>}
    {showForm && <section id="dashboard-form" className="dashboard-form">{children}</section>}
    <ProductList {...listProps} />
    <p className="dashboard-footnote">Comprobamos los precios periódicamente. Cada tarjeta indica cuándo se verificó su precio; una comprobación pendiente no significa necesariamente que no haya stock.</p>
  </main>;
}
